import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {
      this.canvasForm = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(0, 0)`)
      .attr('font-family', 'roboto')
      .attr('cursor', 'default')

      this.canvasForm
      .append('image')
      .attr('id', `TOGGLE_${this.localId}`)
      .attr('cursor', 'pointer')
      .attr('transform', `translate(725, 10)`).attr('height', 10)
      .attr('xlink:href', this.HOST + `/icon/toggle_ON.svg`)
      .call(this.call_Toggle)


      let table = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.table.x}, ${this.table.y})`)

      // table
      // .append('text')
      // .attr('id', `TITLE_${this.localId}`)
      // .attr('transform', `translate(0, 0.5)`)
      // .attr('font-size', 13).attr('fill', '#44A9DF')
      // .text('Erection Status')

      // table
      // .append('text')
      // .attr('transform', `translate(${this.getNode(`#TITLE_${this.localId}`, 'width') + 10}, 0.5)`)
      // .attr('font-size', 9).attr('fill', '#757575')
      // .text(`Erection Status`)

      table
      .append('rect')
      .attr('x', this.table.width + 20).attr('y', 5)
      .attr('width', 400).attr('height', 305)
      .attr('fill', 'none').attr('stroke', '#bcbcbc')
      .attr('stroke-width', .5).attr('opacity', .5)

      let blk_ = this.filterData.find(f=> f.SN == this.current.idx)

      this.loadSvg(
        table, {
        id: `SVG_${this.current.idx}`, 
        x: 340, y: 5,
        url : this.HOST + `/Visualization/Erection_Status/${this.revision}/${this.current.blk}.svg`
      }).then(() => {
        d3.selectAll("text").style('font-family', 'roboto')
        this.coverSVG(blk_) 
        this.ani_Image_ON()
      })

      // Header
      this.columns.forEach(d=> {
        table
        .append('text')
        .attr('transform', `translate(${d.mx}, ${16.5 + 10.5*0.35})`)
        .attr('font-size', 10.5).attr('fill', '#000')
        .attr('text-anchor', d.align)
        .text(d.name)
      })
      this.gmx_Line(table, 0, this.table.width, 6, 6, '#757575', 1, 1)
      this.gmx_Line(table, 0, this.table.width, 27, 27, '#757575', 1, 1)

      this.draw_Contents()
      this.draw_Scrollbar()

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },


  }
}